import React from "react";
import { StarIcon } from "lucide-react";

interface EvaluationsCellProps {
  rating: number;
}

const MAX_RATING = 5;

export const EvaluationsCell: React.FC<EvaluationsCellProps> = ({ rating }) => {
  return (
    <div className="flex gap-2 justify-center">
      {Array.from({ length: rating }).map((_, index) => (
        <StarIcon key={index} className="h-4 w-4 fill-black" />
      ))}

      {Array.from({ length: MAX_RATING - rating }).map((_, index) => (
        <StarIcon key={index} className="h-4 w-4 fill-gray" />
      ))}
    </div>
  );
};
